export class ImageEmbed {
    #element;

    get element() { return this.#element; }

    constructor(metadata, target) {
        this.#element = <img src={metadata.url} alt={(target.dataset.mszEmbedAlt || metadata.url)} />;
    }
}
